export default __webpack_public_path__ + "static/652-9f73224fe73666601570478dd181f4fa.gif";